import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Cinematic comic-panel on-load reveal.
// Uses a reliable timeout to unmount (does not depend on exit-animation completion).
export const IntroReveal = () => {
  const [phase, setPhase] = useState(() => (sessionStorage.getItem("nm_intro_played") ? "gone" : "in"));

  useEffect(() => {
    if (phase === "gone") return;
    sessionStorage.setItem("nm_intro_played", "1");
    const t1 = setTimeout(() => setPhase("out"), 2300);
    const t2 = setTimeout(() => setPhase("gone"), 3000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [phase]);

  if (phase === "gone") return null;

  const panels = [0, 1, 2, 3, 4, 5];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#050806]"
      style={{
        opacity: phase === "out" ? 0 : 1,
        transition: "opacity 0.7s ease",
        pointerEvents: phase === "out" ? "none" : "auto",
      }}
      data-testid="intro-reveal"
    >
      <div className="absolute inset-0 grid grid-cols-2 md:grid-cols-3 grid-rows-3 md:grid-rows-2">
        {panels.map((i) => (
          <motion.div
            key={i}
            className="bg-black border border-emerald-900/40 halftone relative overflow-hidden"
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.1, duration: 0.5, ease: "easeOut" }}
          >
            <motion.div
              className="absolute inset-0 bg-emerald-500/10"
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 0.6, 0] }}
              transition={{ delay: i * 0.1 + 0.1, duration: 0.5 }}
            />
          </motion.div>
        ))}
      </div>

      <motion.div
        className="relative z-10 text-center px-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
      >
        <div className="overflow-hidden">
          <motion.h1
            className="font-display text-6xl sm:text-8xl md:text-9xl"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ delay: 0.9, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <span className="text-emerald-400 text-glow-green">NAIJA</span>
            <span className="text-amber-500">MAN</span>
          </motion.h1>
        </div>
        <motion.p
          className="font-accent text-xl md:text-2xl tracking-[0.35em] text-gray-400 mt-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4, duration: 0.6 }}
        >
          NIGERIA. POWERED. UNSTOPPABLE.
        </motion.p>
      </motion.div>
    </div>
  );
};
